import { Component } from '@verndale/core';
import uniq from 'lodash/uniq';

import { getCookie, setSessionCookie } from '../utils/cookies';

const COOKIE_NAME = 'closed-alerts';

class Alert extends Component {
  setupDefaults() {
    this.dom = {
      $closeBtn: this.el._$('.alert__close-btn')
    };

    this.id = this.el.dataset.id;

    this.removeIfClosed();
  }

  addListeners() {
    const { $closeBtn } = this.dom;

    $closeBtn._on('click', ::this.handleClose);
  }

  handleClose() {
    const closedAlertIds = this.getClosedIds();

    if (closedAlertIds.length) {
      this.addNewClosedId();
    } else {
      this.setClosedIds();
    }

    this.removeAlert();
  }

  addNewClosedId() {
    const closedAlertIds = this.getClosedIds();

    const newClosedAlertIds = uniq([...closedAlertIds, this.id]);

    this.setClosedIds(newClosedAlertIds);
  }

  setClosedIds(alerts = [this.id]) {
    setSessionCookie(COOKIE_NAME, JSON.stringify(alerts));
  }

  getClosedIds() {
    const cookie = getCookie(COOKIE_NAME);

    return cookie ? JSON.parse(cookie) : [];
  }

  removeIfClosed() {
    const closedAlertIds = this.getClosedIds();

    if (closedAlertIds.length && closedAlertIds.includes(this.id)) {
      this.removeAlert();
    } else {
      this.showAlert();
    }
  }

  removeAlert() {
    this.el.parentNode.removeChild(this.el);
  }

  showAlert() {
    this.el.style.display = 'block';
  }
}

export default Alert;
